import { render, staticRenderFns } from "./ReadOnlyAlert.vue?vue&type=template&id=65297f61&"
import script from "./ReadOnlyAlert.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports